/*
 * @Description: 打款总金额列表,根据类型区分加载,内部结算总价也是根据当前类型判断接口
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import unpaidAll from './unpaidAll';
import unpaidPart from './unpaidPart';
import invalid from './invalid';
import paid from './paid';

export default {
  // 未支付-全部未支付
  1: unpaidAll,
  // 未支付-部分成功
  2: unpaidPart,
  // 已支付
  3: paid,
  // 失效
  4: invalid
};
